


































import { BillingModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { billingsStore } from '../+state/store';

@Component({
    components: {
        
    }
})
export default class BillingCreateDialog extends Page {

    partyId: string | null = null;
    fromDate: string | null = null;
    toDate: string | null = null;
    dialog = false;
    valid = true;
    saving = false;

    open () {
        this.dialog = true;
        this.partyId = null;
        this.fromDate = moment().startOf("month").format("YYYY-MM-DDT00:00:00");
        this.toDate = moment().endOf("month").format("YYYY-MM-DDT00:00:00");
    }

    close () {
        this.dialog = false;
    }

    save () {
        this.saving = true;
        const billing = {
            id: Guid.EmptyGuid(),
            partyId: this.partyId,
            fromDate: this.fromDate,
            toDate: this.toDate
        } as BillingModel;
        billingsStore.dispatch(CrudAction.Create, { item: billing });
        this.subscribe(billingsStore, CrudReponse.Create).then((e: BillingModel) => {
            this.saving = false;
            this.close();
            this.$router.push({ name: "Billing", params: { billingId: e.id! } })
        }).catch(() => {
            this.saving = false;
        });
    }

}
